type ShippingMethodType = 'shop' | 'home' | 'packstation';

export type ShippingMethodInfo = {
  amount: number;
  description: string;
  isDefault: boolean;
  id: string;
  orderHint: number;
  type: ShippingMethodType;
  displayName: string;
  thresholdToActivate?: number;
  freeAbove: number;
  currency: number;
};

export enum ShippingType {
  SHIPPING_SAME = 'shipping_same',
  SHIPPING_ALTERNATE = 'shipping_alternate',
  CLICK_COLLECT = 'click_collect',
  CLICK_COLLECT_POPUP = 'click_collect_popup',
  PACKSTATION = 'packstation',
}
